import Vue from 'vue'
import store from '@store'


Vue.prototype.$getErrors = function(key) {

    return _.get(
        store.state.app.errors,
        key,
        []
    )
}

Vue.prototype.$getSize = function(size) {

    if (size < 1024) {
        return size + " B";
    } else if (size < 1024 * 1024) {
        return (size / 1024).toFixed(2) + " KB";
    } else if (size < 1024 * 1024 * 1024) {
        return (size / (1024 * 1024)).toFixed(2) + " MB";
    } else {
        return (size / (1024 * 1024 * 1024)).toFixed(2) + " GB";
    }
}

Vue.prototype.$hasErrors = function(key) {

    return _.get(
        store.state.app.errors,
        key,
        []
    ).length

}
